import {
  AgxColumn,
  AgxRow,
  AgxTypography,
  AgxDivider,
  AgxToggleSwitch,
  AgxCommissionPlan,
  AgxNotificationBox,
} from '@urbanx/agx.ui-components2'
import {
  CommissionDetails,
  FlatCommissionType,
} from '@urbanx/agx.campaigns.client'
import { TaskStepDto } from '@urbanx/agx.activities.client'

export const AgreementCommissionStageSteps = ({
  commissionDetails,
  onCommissionUpdated,
  setCommissionDetailsValid,
  allowedCommissionTypes,
  currentCommissionInfo,
  tasksStage: tasksStage,
  updateTaskStep: updateTaskStep,
}: {
  commissionDetails?: CommissionDetails
  onCommissionUpdated: (updated: { value: CommissionDetails }) => void
  setCommissionDetailsValid: (valid: boolean) => void
  allowedCommissionTypes: any[]
  currentCommissionInfo?: CommissionDetails
  tasksStage: TaskStepDto[]
  updateTaskStep: (step: TaskStepDto, isChecked: boolean) => void
}) => {
  const signatureTask = tasksStage[1]
  return (
    <AgxColumn gap="spacing-xl" fill>
      <AgxCommissionPlan
        id={'commissionPlan'}
        commissionTypes={allowedCommissionTypes}
        onValueChanged={onCommissionUpdated}
        formName={'Agency Agreement'}
        defaultValue={commissionDetails ?? currentCommissionInfo}
        required
        showCommissionRangeDisclaimer
        onValidateStatusChange={setCommissionDetailsValid}
      />

      {!!commissionDetails?.flatCommission &&
        commissionDetails.flatCommission.amount !== undefined &&

        ((commissionDetails.flatCommission.flatCommissionType ===
          FlatCommissionType.Percentage &&
          commissionDetails.flatCommission.amount <= 2.2) || (commissionDetails.flatCommission.flatCommissionType ===
            FlatCommissionType.FlatFee &&
            commissionDetails.flatCommission.amount < 1000)) && (
          <AgxNotificationBox
            type="warning"
            heading=""
            body="Commission rate is low. Alert Admin Manager and confirm rate is correct before proceeding."
          />
        )}

      <AgxDivider variant="horizontal" />

      {signatureTask && (
        <AgxColumn gap="spacing-xl" fill padding={{ bottom: 'spacing-8xl' }}>
          <AgxRow
            gap="spacing-lg"
            justifyContent="space-between"
            alignItems="flex-start"
            fill
          >
            <AgxRow justifyContent="left" alignItems="flex-start">
              <AgxTypography
                id={'lbllicenseeDetails'}
                type={'body_ui'}
                size={'small'}
              >
                {signatureTask.name}
              </AgxTypography>
            </AgxRow>

            <AgxRow justifyContent="right" alignItems="flex-start">
              <AgxToggleSwitch
                id="step"
                checked={signatureTask.isCompleted ?? false}
                onChange={(isChecked: boolean) =>
                  updateTaskStep(signatureTask, isChecked)
                }
              />
            </AgxRow>
          </AgxRow>
        </AgxColumn>
      )}
    </AgxColumn>
  )
}

export default AgreementCommissionStageSteps
